<div class="tdo-dropdown-menu" style="position: relative; cursor: pointer;" [style.width]="width" [style.height]="height" data-cy="multi-dropdown-container">
  <div style="display: flex;"  (click)="validateEnable();" data-cy="multi-dropdown-header">
    <div style="flex: 1; color: var(--tdo-primary-accent)" data-cy="multi-dropdown-label">{{getLabel()}}</div>
    <mat-icon data-cy="multi-dropdown-arrow-icon">keyboard_arrow_down</mat-icon>
  </div>
  <div style="width: 100%; background-color: var(--tdo-primary-accent); height: 2px; margin-top: 2px;" data-cy="multi-dropdown-divider"></div>
  <div class="tdo-dropdown-menu-content tdo-multi-dropdown-menu ui-dark-background" (appClickOutside)="clickOutside()" style="left: 0;" [style.top.px]="height + 8" [ngClass]="{'tdo-dropdown-menu-show': isMenuOpen}" [style.width]="width" data-cy="multi-dropdown-menu">
    <div *ngFor="let item of dataset" [ngClass]="isMultipleCaseItem ? 'tdo-dropdown-menu-item-ByCase' : 'tdo-dropdown-menu-item'"  style="color: var(--tdo-primary); text-align: left;" (click)="toggle(cb, item)" data-cy="multi-dropdown-item">
      <mat-checkbox 
            [checked]="isChecked(item)" 
            style="pointer-events: none; height: fit-content;" 
            #cb 
            labelPosition="before"
            data-cy="multi-dropdown-checkbox">
            {{isMultipleCaseItem ? item[displayKeyByCase] : 'Tooth ' + item[displayKey]}}
        </mat-checkbox>
    </div>
  </div>
</div>
